import React from "react";
import PropTypes from "prop-types";
import { Segment, Header, Button } from "semantic-ui-react";
import ShareButton from "../ShareButton";
import { Document, Page, pdfjs } from "react-pdf";
import API_BASE_URL from "../../config";
const Stats = ({
  totalQuestions,
  resultType,
  resultName,
  wing,
  reportUrl,
  emailSent,
  replayQuiz,
  resetQuiz,
  userInfo,
}) => {
  return (
    <Segment>
      <Header as="h1" textAlign="center" block>
        Kişilik Analizi Sonucu:
      </Header>
      <Header as="h2" textAlign="center" color="teal">
        {resultType}
        {resultName ? ` — ${resultName}` : ""}
        {wing ? ` (${wing})` : ""}
      </Header>
      {emailSent && (
        <Header
          as="h4"
          textAlign="center"
          style={{ color: "gray", marginTop: "-10px" }}
        >
          Sonucunuz {userInfo.email} adresine mail olarak gönderilmiştir.
        </Header>
      )}
      <Header textAlign="center" block>
        <Button
          as="a"
          href={`${API_BASE_URL}${reportUrl}`}
          download
          icon="download"
          content="Kişisel PDF İndir"
          color="blue"
        />
      </Header>
      {/* <Header as="h3" textAlign="center" block>
        Toplam Soru Seti Sayısı: {totalQuestions}
      </Header> */}

      {/* İstersen burada personality type açıklaması da gösterilebilir */}

      <div style={{ marginTop: 35 }}>
        {/* <Button
          primary
          content="Tekrar Başla"
          onClick={replayQuiz}
          size="big"
          icon="redo"
          labelPosition="left"
          style={{ marginRight: 15, marginBottom: 8 }}
        /> */}
        <Button
          color="teal"
          content="Anasayfa"
          onClick={resetQuiz}
          size="big"
          icon="home"
          labelPosition="left"
          style={{ marginBottom: 8 }}
        />
        {/* <ShareButton /> */}
      </div>
    </Segment>
  );
};

Stats.propTypes = {
  totalQuestions: PropTypes.number.isRequired,
  resultType: PropTypes.string.isRequired,
  resultName: PropTypes.string,
  wing: PropTypes.string,
  reportUrl: PropTypes.string.isRequired, // sunucunun imzalı, süreli PDF adresi (/api/report/...?t=...)
  emailSent: PropTypes.bool,
  replayQuiz: PropTypes.func.isRequired,
  resetQuiz: PropTypes.func.isRequired,
};

export default Stats;
